class AdIdGenerator {
  constructor() {
    this.latestId = 0;
  }

  getUniqueId() {
    this.latestId++;
    return `libellus-${this.latestId}`;
  }

  reset() {
    this.latestId = 0;
  }
}

export default AdIdGenerator;



// WEBPACK FOOTER //
// ./src/util/adIdGenerator.js